"use strict";

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/helpers/class-call-check.js
 ** module id = 6
 ** module chunks = 0
 **/